/* A row of pill links under a screen's title: the second level of tabs. The current one is marked
   by a filled pill AND heavier text (never colour alone). Wraps rather than scrolls: it is three
   short words at most. */

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.link {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--bg);
  color: var(--muted);
  font-size: var(--t-dense);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition:
    color var(--dur-1) var(--ease-std),
    background-color var(--dur-1) var(--ease-std);
}

.link:hover {
  color: var(--ink);
  background: var(--panel-2);
}

.link:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.link[data-active="true"] {
  border-color: var(--ink);
  background: var(--panel-3);
  color: var(--ink);
  font-weight: 650;
}

@media (max-width: 560px) {
  .link {
    min-height: var(--target-touch);
  }
}
